/** 弹性裸金属计价复合资源 code（SKU / 下单 VendorAndDeviceRadioList） */
export const EBM_NODE_RESOURCE_CODE = 'ElasticBareMetalNode';
